import { normalizeElement } from './normalize-element'

export const normalizeGnb = (rawData) => {
  return {
    id: rawData?.id ?? '',
    isDefault: rawData?.is_default ?? '',
    showTopBar: rawData?.show_top_bar ?? '',
    fullScreenMode: rawData?.full_screen_mode ?? '',
    elementList: rawData?.element_list?.map(normalizeElement),
  }
}
